<template>
  <div class="leftNav">
    <div id="head_img">
      <div class="rightgo">
        <div class="directSend" v-if="shopType === '1'">直发</div>
        <div class="inDirectSend" v-if="shopType === '0'">平台</div>
        <div class="directSend" v-if="shopType === '2'">工厂</div>
        <!-- <img src="@/assets/img/indirectsend.png" alt="" v-if="shopType === '0'"> -->
        <!-- <img src="@/assets/img/directsend.png" alt="" v-if="shopType === '1'"> -->
      </div>
    </div>
    <p class="login_name">{{user}}</p>
    <p class="login_info">欢迎登录!</p>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
      unique-opened
      ref="menu"
    >
    <order-nav @rediret="rediret"></order-nav>
    <aftersale-nav @rediret="rediret"></aftersale-nav>
    <stock-nav @rediret="rediret"></stock-nav>
    <report-nav @rediret="rediret"></report-nav>
    <basic-nav ref="basicNav" @rediret="rediret"></basic-nav>
    <!-- <user-set @rediret="rediret" v-if="jzb_enable"></user-set> -->
    </el-menu>
  </div>
</template>
<script>
import basicNav from '@/components/layout/leftnav/basicNav'
import orderNav from '@/components/layout/leftnav/orderNav'
import reportNav from '@/components/layout/leftnav/reportNav'
import stockNav from '@/components/layout/leftnav/stockNav'
import aftersaleNav from '@/components/layout/leftnav/aftersaleNav'
import userSet from '@/components/layout/leftnav/userSet'
// import {jzbReqAcc} from '@/models/jzbModel'
// import userSetRouter from '@/router/userSet/binding'
// import router from '@/router/index'
// import router, { resetRouter } from '@/router'
import {mapGetters} from 'vuex'
export default {
  components: {basicNav, orderNav, stockNav, reportNav, aftersaleNav, userSet},
  props: ['menuList', 'ptitle'],
  data () {
    return {
      user: localStorage.getItem('username'),
      shopType: localStorage.getItem('shop_type'),
      activeIndex: ''
    }
  },
  computed: {
    ...mapGetters(['jzb_enable'])
  },
  mounted () {
    // 点击3次头像显示
    let btn = document.getElementById('head_img')
    let that = this
    this.nclickEvent(5, btn, function (event, n) {
      that.$refs.basicNav.showCBpage()
    })
    if (localStorage.getItem('activeIndex')) {
      console.log('activeIndex', localStorage.getItem('activeIndex'))
      this.activeIndex = localStorage.getItem('activeIndex')
    }
  },
  methods: {
    nclickEvent (n, dom, fn) {
      dom.removeEventListener('dblclick', null)
      n = parseInt(n) < 1 ? 1 : parseInt(n)
      let count = 0
      let lastTime = 0
      let handler = function (event) {
        let currentTime = new Date().getTime()
        count = (currentTime - lastTime) < 300 ? count + 1 : 0
        lastTime = new Date().getTime()
        if (count >= n - 1) {
          fn(event, n)
          count = 0
        }
      }
      dom.addEventListener('click', handler)
    },
    rediret (item) {
      try {
        if (item.url === this.$route.path) {
          this.$router.push('/order/test') // 跳转页面想同则刷新当前页面
        } else {
          this.$router.push(item.url)
          this.activeIndex = item.index
          localStorage.setItem('activeIndex', item.index)
        }
      } catch (ex) {}
    },
    async showJzbMenu () {
      // let vm = this
      // setTimeout(function () {
      //   if (typeof vm.$store.getters.jzb_enable !== 'boolean') {
      //     vm.$store.dispatch('jzb/jzb_enable_change')
      //   }
      // }, 1000)
    }
  },
  created () {
    // this.showJzbMenu()
  }
}
</script>

<style lang="scss">
$commonFontSize: 14px;
.leftNav {
  margin-top: -10px;
  background-color: #303a43;
  .el-menu-item {
    font-size: $commonFontSize;
    background-color: #242e37 !important;
    border-bottom: 1px solid rgb(33, 42, 50);
    // width: 100%;
    text-align: center
    // margin-left: -40px;
  }
  .el-menu-item:hover {
    background-color: #1d252c !important;
  }
  .el-menu-item.is-active {
    background-color: #1d252c !important;
    color: #ff6224 !important;
    border-left: 5px solid #ff6224;
  }
  .el-menu {
    // border-left: 5px solid #ff6224;
    border: none;
  }
  #head_img {
    position: relative;
    width: 70px;
    height: 70px;
    margin-left: 50px;
    margin-top: 10px;
    top: 5px;
    border-radius: 50%;
    text-align: center;
    background: url(../../../assets/img/default.jpg) no-repeat;
    background-size: 70px 70px;
    .rightgo {
      width: 50px;
      height: 15px;
      border-radius: 7px;
      overflow: hidden;
      position: absolute;
      bottom: -5px;
      left: 50%;
      font-size: 12px;
      line-height: 16px;
      color:#fff;
      transform: translateX(-50%);
      // img {
      //   width: 100%;
      //   height: 100%;
      // }
      .directSend {
        background-color: blue;
      }
      .inDirectSend {
        background-color: #ff2e2e;
      }
    }
  }
  .login_name {
    color: rgb(191, 203, 217);
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
    // margin-left: -10px;
  }
  .login_info {
    color: rgb(191, 203, 217);
    text-align: center;
    font-size: 14px;
    margin-top:-10px;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/leftnav/leftNav.vue